export default __webpack_public_path__ + "static/media/ic_sentiment_neutral_48px.fd9e7058.svg";